import React from 'react';
import notfound from '../../assets/images/notfound.png';

const NotFound = () => {
    return (
        <div data-aos="fade-up" data-aos-duration="2500" className="py-16">
            <div className="flex justify-center mb-12">
                <img
                    className="sm:max-w-sm"
                    src={notfound}
                    alt="404 not found"
                />
            </div>
            <h2 className="text-4xl text-center text-accent leading-normal">
                Oops! The page your are looking for <br /> that's not found :(
            </h2>
        </div>
    );
};

export default NotFound;
